export const GET_USERS = 'GET_USER';
export const SHOW_LOADING_USERS = 'SHOW_LOADING_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const SET_USER_SELECTED = 'SET_USER_SELECTED';
export const SET_PHONE_USER_SELECTED = 'SET_PHONE_USER_SELECTED';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';
export const SET_EDIT_FIELD = 'SET_EDIT_FIELD';
export const SET_LEGAL_AGENT_USER = 'SET_LEGAL_AGENT_USER';
export const USERS_SET_FILTER = 'USERS_SET_FILTER';
export const USERS_RESET_FILTER = 'USERS_RESET_FILTER';
export const GET_OPSCORE_SUCCESS = 'GET_OPSCORE_SUCCESS';
export const GET_OPSCORE_ERROR = 'GET_OPSCORE_ERROR';
